import React from 'react';
import { connect } from 'react-redux';
//import * as actions from '../actions.js';
import './App.css';
import Introduction from './Introduction.js';
import HashDemo from './HashDemo.js';
import MerkleDemo from './MerkleDemo.js';
import PublicKeyDemo from './PublicKey.js';
import BlockMiningDemo from './BlockMining.js';
import TransactionsDemo from './TransactionsDemo.js';
import ChainDemo from './ChainDemo.js';
import PaymentChannelDemo from './PaymentChannel.js';

import {
    Navbar,
    Tabs,
    Tab,
} from 'react-bootstrap';

function App() {
    return (
        <div>
            <Navbar>
                <Navbar.Header>
                    <Navbar.Brand>
                        <img src="main_logo.png" alt="Catallaxy" />
                    </Navbar.Brand>
                </Navbar.Header>
            </Navbar>
            <Tabs defaultActiveKey="intro" animation={false} id="maintabcontainer">
                <Tab eventKey="intro" title="Introduction">
                    <Introduction />
                </Tab>
                <Tab eventKey="hash" title="Hash Functions">
                    <HashDemo />
                </Tab>
                <Tab eventKey="merkle" title="Merkle Trees">
                    <MerkleDemo />
                </Tab>
                <Tab eventKey="publickey" title="Public Keys">
                    <PublicKeyDemo />
                </Tab>
                <Tab eventKey="blockmining" title="Block Mining">
                    <BlockMiningDemo />
                </Tab>
                <Tab eventKey="transactions" title="Transactions">
                    <TransactionsDemo />
                </Tab>
                <Tab eventKey="chain" title="Chain" disabled>
                    <ChainDemo />
                </Tab>
                <Tab eventKey="paymentchannel" title="Payment Channel" disabled>
                    <PaymentChannelDemo />
                </Tab>
            </Tabs>
            <footer className="pagefooter">
                { (new Date()).getFullYear() }
            </footer>
        </div>
    );
}

function stateToProps() {
    return {};
}
function dispatchToProps(dispatch) {
    return {};
}

export default connect(stateToProps, dispatchToProps)(App);




// WEBPACK FOOTER //
// ./src/components/App.js